import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useProgressSuccess } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as selectors from '../../selectors';
import messages from '../../messages';
const Actions = ({ onClose })=>{
    const isInProgress = useSelector(selectors.isConnectInProgress);
    const hasErrors = useSelector(selectors.hasConnectErrors);
    useProgressSuccess(isInProgress, hasErrors, onClose);
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__actions row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    className: "btn--block",
                    labelMessage: App.messages.buttons.close,
                    isDisabled: isInProgress,
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    className: "btn--block btn--filled",
                    type: "submit",
                    labelMessage: messages.buttons.connect,
                    isInProgress: isInProgress
                })
            })
        ]
    });
};
export default /*#__PURE__*/ memo(Actions);
